<div class="compat-groups">
  <div class="row mt-5 row-headers" style="background-color: black;height: 90px; padding-left: 5px;padding-right: 5px;">
    <div class="col-12" style="text-align:center;">
      <h4>Compatibility Group</h4>
    </div>
    <div class="col-12 search-container">
      <input class="form-control" [(ngModel)]="searchString" type="text" placeholder="Search" (keyup)="filterGroups(searchString)"/>
    </div>
  </div>
  <div class="custom_small_panelbody_fix_ghome">
    @if (filteredGroups) {
      <div>
        <mat-radio-group (change)="onSelectionChange($event)">
          @for (compatGroup of filteredGroups; track compatGroup) {
            <mat-radio-button [value]="compatGroup" class="radio-button">
              {{ compatGroup.globalControllerGroupName }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>
    }
  </div>
</div>